import { addMicrotask } from './utils';
// 不使用符号，方便跨 Realms
export const HANDLES_KEY = 'gem@storeHandlesKey';
export function createStore(originStore) {
    const store = originStore;
    // 序列化时忽略
    Object.defineProperty(store, HANDLES_KEY, { enumerable: false, value: new Set(), writable: true });
    return store;
}
export function createStoreSet(originStoreSet) {
    const keys = Object.keys(originStoreSet);
    keys.forEach(key => {
        const store = originStoreSet[key];
        createStore(store);
    });
    return originStoreSet;
}
export function updateStore(store, value) {
    Object.assign(store, value);
    const listeners = store[HANDLES_KEY];
    listeners.forEach(func => {
        addMicrotask(func);
    });
}
export function connect(store, func) {
    const listeners = store[HANDLES_KEY];
    listeners.add(func);
}
export function disconnect(store, func) {
    const listeners = store[HANDLES_KEY];
    listeners.delete(func);
}
//# sourceMappingURL=store.js.map